// Customizer const
export const LIGHT_THEME = 'light'
export const DARK_THEME = 'dark'
export type TeamsThemeType = 'default' | 'dark' | 'contrast'

// Ant Design v5 theme customization
export const lightThemeToken = {
  token: {
    colorPrimary: '#7f00ff',
    colorLink: '#7f00ff',
    colorInfo: '#7f00ff',
    fontFamily: 'NoirPro, sans-serif',
  },
  components: {
    Dropdown: {
      zIndexPopup: 10000,
    },
    Statistic: {
      contentFontSize: 18,
    },
  },
  inherit: true,
}

export const darkThemeToken = {
  token: {
    colorPrimary: '#d1a3ff',        
    colorInfo: '#d1a3ff',           
    colorTextBase: '#F0F3F9',
    colorBgBase: '#1C222B',
    colorBgContainer: '#252B35',
    colorBorder: '#495862',         
    colorBorderSecondary: '#495862',
    fontFamily: 'NoirPro, sans-serif',
  },
  components: {
    Button: {
      colorBgContainer: '#252B35',
      // Primary buttons - Stronger purple
      colorPrimary: '#7f00ff',          // Stronger purple tone
      colorPrimaryHover: '#a855ff',     // Lighter for hover
      colorPrimaryActive: '#7c1dff',    // Darker for active/pressed
      colorPrimaryBorder: '#8f2aff',    // Match primary
      
      // Danger buttons - Remove box shadow
      colorError: '#ff4d4f',            // Standard danger color
      colorErrorHover: '#ff7875',       // Lighter for hover
      colorErrorActive: '#d9363e',      // Darker for active
      colorErrorBorder: '#ff4d4f',      // Match danger color
      
      // Remove all box shadows
      boxShadow: 'none',
      primaryShadow: 'none',
      dangerShadow: 'none',
      defaultShadow: 'none',
      
      // Default buttons - Secondary colors
      defaultBg: '#2D3748',             // dark-theme-secondary-color
      defaultColor: '#F0F3F9',          // Light text
      defaultBorderColor: '#495862',    // Dark border
      defaultHoverBg: '#374151',        // Slightly lighter on hover
      defaultHoverColor: '#F0F3F9',     // Keep text light
      defaultHoverBorderColor: '#6B7280', // Lighter border on hover
    },
    Input: {
      colorBorder: '#495862',           // Dark theme border
      colorPrimaryHover: '#8f2aff',     // Use stronger purple for focus
    },
    Select: {
      colorBorder: '#495862',           // Dark theme border  
      colorPrimaryHover: '#8f2aff',     // Use stronger purple for focus
    },
    Table: {
      colorBgContainer: '#252B35',      // Match main-content wrapper background
      headerBg: '#252B35',              // Table header background
      bodySortBg: '#252B35',            // Sorted column background
      headerSortActiveBg: '#2D3748',    // Active sort header background
      headerSortHoverBg: '#2D3748',     // Hover sort header background
      rowHoverBg: '#2D3748',            // Row hover background
      rowSelectedBg: '#2D3748',         // Selected row background
      rowSelectedHoverBg: '#374151',    // Selected row hover background
      colorBorder: '#495862',           // Table border color
      colorSplit: '#495862',            // Table split line color
    },
    Statistic: {
      contentFontSize: 18,
    },
    Dropdown: {
      zIndexPopup: 10000,
    },
  },
  inherit: true,
}